import Link from "next/link"
import React from "react"
import { BrandLetterGroups } from "../../../../contents/brands/types"
import { brandPagePath } from "../../../../root/routing/urls"
import Typography from "../../../../ui/atoms/Typography"
import classes from "./BrandsPanel.module.css"

interface Props {
  brands: BrandLetterGroups
}

export const buildPanelItemId = (letter: string) =>
  `bl-${letter}`.toLocaleLowerCase()

const BrandsPanel = ({ brands }: Props) => {
  return (
    <div className={classes.root}>
      {brands.map((x) => (
        <div
          id={buildPanelItemId(x.letter)}
          key={x.letter}
          className={`mb-12 ${classes.panelItem}`}
        >
          <Typography
            variant="h4"
            component="p"
            weight="normal"
            className={classes.letter}
          >
            {x.letter.toUpperCase()}
          </Typography>
          {x.brands.map((brand) => (
            <div key={brand.slug} className="my-1">
              <Link href={brandPagePath(brand.slug)} passHref>
                <a className={classes.brandName}>{brand.name}</a>
              </Link>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default BrandsPanel
